import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='recurringPaymentDescription' subtitle='String?' mdxType="Item">
	Set the payment description that will be shown on the Klarna screen.
    </Item>
    <Item title='webViewTitle' subtitle='String?' label='Default: Klarna' mdxType="Item">
      <p>{`⚠️ This option is `}<inlineCode parentName="p">{`Deprecated`}</inlineCode>{`.
Sets the toolbar title of the Activity displaying Klarna views.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      